import React, { useState } from 'react';
import { MailOutline } from 'Components/Atoms/Icons';
import { SupportConversationDocument } from 'types/shared/documents/support';

type Props = {
  conversation: SupportConversationDocument;
  /** Pre-filled address (current user, or the restaurant for tablet logins). */
  defaultEmail: string;
  onSave: (email: string) => void | Promise<void>;
};

const NotifyByEmail = ({ conversation, defaultEmail, onSave }: Props) => {
  // The backend may default notifyEmail server-side, so treat notifyByEmail
  // alone as active and always show a resolved address.
  const active = !!conversation.notifyByEmail;
  const displayEmail = conversation.notifyEmail || defaultEmail;
  const [editing, setEditing] = useState(false);
  const [email, setEmail] = useState(displayEmail);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const trimmed = email.trim();
    if (!trimmed || saving) return;
    setSaving(true);
    try {
      await onSave(trimmed);
      setEditing(false);
    } catch {
      // ignore — stay in edit mode so the user can retry
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="support-notify">
        <input
          className="support-notify__input"
          type="email"
          value={email}
          placeholder="deine@email.de"
          disabled={saving}
          autoFocus
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              save();
            }
          }}
        />
        <button
          type="button"
          className="support-notify__save"
          disabled={saving || !email.trim()}
          onClick={save}
        >
          Speichern
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      className="support-notify__ghost"
      onClick={() => {
        setEmail(displayEmail);
        setEditing(true);
      }}
    >
      <MailOutline fontSize="inherit" />
      {active
        ? `Benachrichtigung an ${displayEmail} – ändern`
        : 'Per E-Mail benachrichtigen lassen'}
    </button>
  );
};

export default NotifyByEmail;
